"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      hoveredTab: null,
      imgCodeList: [{
        url: require("../../../assets/img/weixinpublic.jpg"),
        text: '扫描关注微信公众号'
      }, {
        url: require("../../../assets/img/ios.jpg"),
        text: '下载IOS小程序'
      }, {
        url: require("../../../assets/img/weixin.jpg"),
        text: '下载安卓小程序'
      }],
      navTabList: [{
        name: '订舱'
      }, {
        name: '我的订舱'
      }, {
        name: '订舱(日本)'
      }, {
        name: '订舱'
      }, {
        name: '我的订舱'
      }, {
        name: '订舱(日本)'
      }],
      tabList: [{
        name: '船期查询'
      }, {
        name: '船舶动态&汇率'
      }, {
        name: '货物跟踪'
      }],
      navList: [{
        nameEn: 'Home',
        nameZh: '首页',
        path: '/home'
      }, {
        nameEn: 'Schedule',
        nameZh: '船期',
        path: '/basicInfo/product'
      }, {
        nameEn: 'Booking',
        nameZh: '订舱',
        path: '/basicInfo/about'
      }, {
        nameEn: 'Information',
        nameZh: '信息查询',
        path: '/basicInfo/solution'
      }, {
        nameEn: 'Equipment',
        nameZh: '箱管',
        path: '/basicInfo/service'
      }, {
        nameEn: 'Inbound',
        nameZh: '进口',
        path: '/basicInfo/contact'
      }]
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  methods: {
    handleGoto: function handleGoto(item) {
      console.log(item.path);
      this.$router.push({
        path: item.path
      });
    },
    handleLogOut: function handleLogOut() {
      var _this = this;
      this.$confirm(this.$t('home.logOutMessage'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('home.sumit'),
        cancelButtonText: this.$t('home.cancelButton'),
        type: 'warning'
      }).then(function () {
        _this.$store.dispatch('user/logoutAuth');
        _this.$router.push({
          path: '/home'
        });
      }).catch(function () {});
    },
    handleSetLanguage: function handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('app/setLanguage', lang);
      /* 刷新 */
      // this.$message({
      //   message: this.language === 'zh' ? '语言切换成功' : 'Switch Language Success',
      //   type: 'success'
      // })
      // 刷新页面
      window.location.reload();
    },
    handleGoLogin: function handleGoLogin() {
      // this.$router.push('/login')
    },
    handleToUserCenter: function handleToUserCenter() {
      this.$router.push({
        path: '/userCenter/userCenter'
      });
    },
    hoverTabLeave: function hoverTabLeave() {
      this.hoveredTab = null;
      this.navTabList = [];
    },
    selectSecondTab: function selectSecondTab(index) {
      if (index === 4) {
        this.navTabList = [{
          name: this.$t('home.importOne'),
          path: '/basicInfo/userGuide'
        }, {
          name: this.$t('home.importTwo'),
          path: '/basicInfo/product'
        }, {
          name: this.$t('home.importThree'),
          path: '/basicInfo/solution'
        }, {
          name: this.$t('home.importFour'),
          path: '/basicInfo/service'
        }, {
          name: this.$t('home.importFive'),
          path: '/basicInfo/about'
        }, {
          name: this.$t('home.importSix'),
          path: '/basicInfo/contact'
        }];
      }
      if (index === 2) {
        this.navTabList = [{
          name: this.$t('home.controlOne'),
          path: '/basicInfo/userGuide'
        }, {
          name: this.$t('home.controlTwo'),
          path: '/basicInfo/product'
        }, {
          name: this.$t('home.controlThree'),
          path: '/basicInfo/solution'
        }, {
          name: this.$t('home.controlFour'),
          path: '/basicInfo/service'
        }, {
          name: this.$t('home.controlFive'),
          path: '/basicInfo/about'
        }, {
          name: this.$t('home.controlSix'),
          path: '/basicInfo/contact'
        }, {
          name: this.$t('home.controlSeven'),
          path: '/basicInfo/contact'
        }, {
          name: this.$t('home.controlEight'),
          path: '/basicInfo/contact'
        }, {
          name: this.$t('home.controlNine'),
          path: '/basicInfo/contact'
        }];
      }
      if (index === 3) {
        this.navTabList = [{
          name: this.$t('home.infoOne'),
          path: '/basicInfo/userGuide'
        }, {
          name: this.$t('home.infoTwo'),
          path: '/basicInfo/product'
        }, {
          name: this.$t('home.infoThree'),
          path: '/basicInfo/solution'
        }, {
          name: this.$t('home.infoFour'),
          path: '/basicInfo/service'
        }, {
          name: this.$t('home.infoFive'),
          path: '/basicInfo/about'
        }, {
          name: this.$t('home.infoSix'),
          path: '/basicInfo/contact'
        }];
      }
      if (index === 5) {
        this.navTabList = [{
          name: this.$t('home.containerOne'),
          path: '/basicInfo/userGuide'
        }, {
          name: this.$t('home.containerTwo'),
          path: '/basicInfo/product'
        }, {
          name: this.$t('home.containerThree'),
          path: '/basicInfo/solution'
        }, {
          name: this.$t('home.containerFour'),
          path: '/basicInfo/service'
        }];
      }
      if (index === 1) {
        this.navTabList = [{
          name: this.$t('home.vesselOne'),
          path: '/basicInfo/userGuide'
        }, {
          name: this.$t('home.vesselTwo'),
          path: '/basicInfo/product'
        }, {
          name: this.$t('home.vesselThree'),
          path: '/basicInfo/solution',
          'iconAuth': false,
          'iconLogin': true
        }];
      }
    },
    adjustSecondTabPosition: function adjustSecondTabPosition(index) {
      // 获取当前鼠标移动到的container-box-item元素
      var containerBoxItem = this.$refs.containerBoxItem[index];
      var rect = containerBoxItem.getBoundingClientRect();

      // 获取container-list-tab元素
      var containerListTab = this.$refs.containerListTab;

      // 设置container-list-tab的位置
      // containerListTab.style.top = `${rect.bottom}px`;
      var left = rect.left < 425 ? 425 : rect.left;
      containerListTab.style.left = "".concat(left, "px");

      // 获取container-list-tab的尺寸
      var tabRect = containerListTab.getBoundingClientRect();

      // 获取窗口的宽度
      var windowWidth = window.innerWidth;

      // 检查container-list-tab是否超出了屏幕的宽度
      if (tabRect.right > windowWidth) {
        // 调整container-list-tab的left属性，使其完全在屏幕内
        containerListTab.style.left = "".concat(windowWidth - tabRect.width, "px");
      }
    },
    hoverTab: function hoverTab(index) {
      this.hoveredTab = index;
      this.selectSecondTab(index);
      this.adjustSecondTabPosition(index);
    }
  }
};